import { useEffect, useState } from "react";
import AdminBoxConent from "../../components/admin/AdminBoxContent";
import UserTag from "../../models/userTag";
import userSyncService from "../../services/userSyncService";
import SyncAction from "../../models/syncAction";
import Moment from "react-moment";
import dateTimeHelper from "../../util/dateTimeHelper";
import userSyncManager from "../../models/userSyncManager";

const UserTags: React.FC<{}> = () => {
  const [allUserTags, setAllUserTags] = useState<UserTag[]>([]);
  const [userTags, setUserTags] = useState<UserTag[]>([]);
  const [searchText, setSearchText] = useState<string>("");

  const [lastSyncDate, setLastSyncDate] = useState<Date>();

  const [isBusy, setIsBusy] = useState<boolean>(false);

  useEffect(() => {
    const init = async () => {
      const { data: userTags } = await userSyncService.getUserTags();
      setAllUserTags(userTags);
      setUserTags(userTags);

      await updateLastSyncDate();
    };

    setIsBusy(true);

    init();
  }, []);

  const onSearchTextChange = (event: any) => {
    const value = event.target.value;
    setSearchText(value);

    const searchToken = event.target.value.toLowerCase();

    const filteredUserTags = allUserTags.filter((t) =>
      t.tagName.toLowerCase().includes(searchToken)
    );

    setUserTags(filteredUserTags);
  };

  const onSyncTags = async () => {
    setIsBusy(true);

    const { data: userTags } = await userSyncService.syncUserTags();
    setUserTags(userTags);

    await updateLastSyncDate();
  };

  const updateLastSyncDate = async () => {
    const { data: syncStatus } = await userSyncService.getUserSyncStatus();
    const status = syncStatus.find((s) => s.syncAction === SyncAction.SyncTags);
    setLastSyncDate(status?.endDate);

    const isBusy = userSyncManager.checkIsSyncInProgress(syncStatus);
    setIsBusy(isBusy);
  };

  return (
    <AdminBoxConent
      title="User Tags"
      hasCount={true}
      count={userTags.length}
      countType="user tags"
      hasAddNew={true}
      isAddNewEnabled={!isBusy}
      addNewTitle="Sync Tags"
      onAddNew={onSyncTags}
      beforeAddNewContent={
        <div className="me-2" style={{ fontSize: "12px", marginTop: "-4px" }}>
          Last Sync:{" "}
          {lastSyncDate && (
            <Moment format={dateTimeHelper.dateTimeFormat}>
              {lastSyncDate}
            </Moment>
          )}
          {!lastSyncDate && "-"}
        </div>
      }
      hasCurrentOrganizationDropdown={false}
    >
      <div className="mb-3">
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Search"
            value={searchText}
            onChange={onSearchTextChange}
          />
          <button type="submit" className="btn btn-primary">
            Search
          </button>
        </div>
      </div>
      <table className="table table-hover">
        <thead>
          <tr>
            <th scope="col">User Tag</th>
          </tr>
        </thead>
        <tbody>
          {userTags.map((userTag: UserTag, index) => (
            <tr key={index.toString()}>
              <td>
                <span className="user-tag">{userTag.tagName}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminBoxConent>
  );
};

export default UserTags;
